var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgListCheck = function SvgListCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "list_check_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#list_check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.086 20.423 4.654-4.654a.89.89 0 0 1 .659-.275q.38.003.658.294.26.285.26.661t-.26.657l-5.149 5.168q-.34.339-.79.339-.453 0-.792-.339l-2.555-2.555a.87.87 0 0 1-.253-.653.9.9 0 0 1 .265-.653.89.89 0 0 1 .655-.26q.395 0 .65.26zm0-9.52L11.74 6.25a.9.9 0 0 1 .659-.275q.38.003.658.294.26.285.26.661t-.26.657l-5.149 5.168q-.34.339-.79.339-.453 0-.792-.34L3.771 10.2a.87.87 0 0 1-.253-.652.9.9 0 0 1 .265-.653.89.89 0 0 1 .655-.26q.395 0 .65.26zM17.2 20.698a.9.9 0 0 1-.668-.27.9.9 0 0 1-.27-.668q0-.398.27-.668a.9.9 0 0 1 .668-.269h8.75q.399 0 .668.27.27.27.27.668 0 .399-.27.668a.9.9 0 0 1-.668.27zm0-9.52a.9.9 0 0 1-.668-.269.9.9 0 0 1-.27-.668q0-.399.27-.668.27-.27.668-.27h8.75q.399 0 .668.27.27.27.27.669t-.27.668a.9.9 0 0 1-.668.269z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgListCheck);
export default ForwardRef;